// extracted by mini-css-extract-plugin
export default {"intro":"styles_intro__8w9Ko","title":"styles_title__Dr7oZ","block":"styles_block__XQAE-"};